import { CommonService } from 'api-new/generated';
import { QueryError } from 'features/shared/model';
import { UseQueryOptions, useQuery } from 'react-query';

export const useGetSoHeaderTrackerStatusQueryKey = 'useGetSoHeaderTrackerStatusQueryKey';

type SoHeaderTrackerStatusInput = {
  soHeaderId: number;
};

export const useGetSoHeaderTrackerStatusQuery = <TQueryKey extends Array<unknown> = unknown[]>(
  input: SoHeaderTrackerStatusInput,
  queryKey?: TQueryKey,
  options?: Omit<
    UseQueryOptions<
      Awaited<ReturnType<typeof CommonService.getCommonSoHeaderTrackerStatus>>,
      QueryError,
      Awaited<ReturnType<typeof CommonService.getCommonSoHeaderTrackerStatus>>,
      unknown[]
    >,
    'queryKey' | 'queryFn' | 'initialData'
  >
) =>
  useQuery(
    [useGetSoHeaderTrackerStatusQueryKey, ...(queryKey ?? []), input],
    () => CommonService.getCommonSoHeaderTrackerStatus(input.soHeaderId),
    options
  );
